import Formatter from 'shared/utils/formatters'
import ICreateMotoristasRequest from '../entities/ICreateMotoristasRequest'
import IMotorista from '../entities/IMotorista'
import { IMotoristaRepository } from '../repositories/IMotoristaRepository'

export interface ICreateMotorista {
  execute(params: ICreateMotoristasRequest): Promise<IMotorista>
}

export default class CreateMotoristaImpl implements ICreateMotorista {
  constructor(private readonly motoristaRepository: IMotoristaRepository) {}
  async execute({
    endereco,
    frotista_id,
    telefone,
    doc_imagem_frente,
    doc_imagem_verso,
    doc_token_sdk,
    motorista_referencia,
    email,
  }: ICreateMotoristasRequest): Promise<IMotorista> {
    return this.motoristaRepository.create({
      frotista_id,
      telefone,
      doc_imagem_frente,
      doc_imagem_verso,
      doc_token_sdk,
      endereco: {
        ...endereco,
        cep: endereco.cep.replace(Formatter.somenteNumeros(), ''),
      },
      motorista_referencia,
      email,
    })
  }
}
